import { API_URLS } from '@helpers/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import qs from 'query-string';
export const retrieveVariantProduct = createAsyncThunk('product/retrieve/variant', async (params) => {
    const response = await fetch(`${API_URLS.variantProduct}?${qs.stringify(params)}`);
    return (await response.json());
});
